import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRouteStore } from "@/store/RouteStore";

// ---------------------- Hook

export const useRouteTracker = () => {
  // --------- Variables / Hooks

  const { pathname } = useLocation();

  const { currentRoute, setCurrentRoute, setPreviousRoute } = useRouteStore();

  // --------- Effects

  useEffect(() => {
    if (currentRoute !== pathname) {
      setPreviousRoute(currentRoute);
      setCurrentRoute(pathname);
    }
  }, [pathname, currentRoute, setCurrentRoute, setPreviousRoute]);
};
